import { api } from '../../core/network/api';
import type { CharacterClassId } from '../config/character-roster';

/** design/gdd/character-creation.md REST surface — plain wrappers, same convention as contracts-api.ts. */

export interface CharacterRow {
  id: string;
  name: string;
  characterClass: CharacterClassId;
  level: number;
  xp: number;
  talents: Record<string, number>;
  talentPointsAvailable: number;
  talentPointsSpent: number;
}

export interface TalentNodeRow {
  id: string;
  tier: 1 | 2 | 3;
  maxRank: number;
  field?: string;
  perRank?: number;
  isCapstone?: boolean;
}

export const listCharacters = (): Promise<CharacterRow[]> => api.get('/characters');

export const getTalentTree = (characterClass: CharacterClassId): Promise<TalentNodeRow[]> =>
  api.get(`/characters/talent-tree/${characterClass}`);

export const createCharacter = (name: string, characterClass: CharacterClassId): Promise<CharacterRow> =>
  api.post('/characters', { name, characterClass });

export const deleteCharacter = (id: string): Promise<void> => api.post(`/characters/${id}/delete`);

export const allocateTalent = (characterId: string, nodeId: string): Promise<CharacterRow> =>
  api.post(`/characters/${characterId}/talents`, { nodeId });

export const respecCharacter = (characterId: string): Promise<CharacterRow> =>
  api.post(`/characters/${characterId}/respec`);

/**
 * How many delvers this account may keep, and what another one costs.
 *
 * The price is the server's, not the client's mirrored constant: a button
 * quoting a number the server has since changed is a button that lies.
 */
export interface CharacterSlots {
  used: number;
  total: number;
  costEmber: number;
}

export const getCharacterSlots = (): Promise<CharacterSlots> => api.get('/characters/slots');

export const buyCharacterSlot = (): Promise<CharacterSlots> => api.post('/characters/slots/buy');
